{
    "ReportlistMyreportlist": "My Report List",
    "ReportlistAddreport": "Add Report",
    "ReportlistAdddefaultreport": "Add Default Report",
    "ReportlistDeletereport": "Delete Report",
    "ReportlistMoreoptions": "More options",
    "ReportlistModifyreport": "Modify Report",
    "ReportlistCopyreport": "Copy Report",
    "ReportlistRenamefolder": "Rename Folder",
    "ReportlistRenamereport": "Rename Report",
    "NoreportsconfiguredText": "No Reports Configured.",
    "ReportlistRecyclebin": "Recycle Bin",
    "ReportlistEmptyrecyclebin": "Empty Recycle Bin",
    "ReportlistRestoreallreports": "Restore All Reports",
    "ReportlistRestorereport": "Restore Report",
    "ReportlistDeletereportsinfolder": "Delete Folder Content",
    "ReportlistRestorereportsinfolder": "Restore Folder Content",
    "ReportlistNoreportswererestored": "No reports were restored.",
    "ReportlistReportwasrestored": "Report was restored.",
    "ReportlistReportswererestored": "{} reports were restored.",
    "ReportlistXoutofyselectedreportswererestored": "{} out of {} selected reports were restored.",
    "ReportlistRestoregenericfailurereason": "The failed report(s) might have been already restored or permanently deleted.",
    "ReportlistNoreportsweremovedtobin": "No reports were moved to recycle bin.",
    "ReportlistReportwasmovedtobin": "Report was moved to recycle bin.",
    "ReportlistReportsweremovedtobin": "{} reports were moved to recycle bin.",
    "ReportlistXoutofyselectedreportsweremovedtobin": "{} out of {} selected reports were moved to recycle bin.",
    "ReportlistMovetobingenericfailurereason": "The failed report(s) might have been already moved to bin.",
    "ReportlistThirtydaysremaining": "This will remain in your recycling bin for 30 days or until emptied.",
    "ReportlistBeendeleted": "has been deleted.",
    "ReportlistNoreportsweredeletedpermanently": "No reports were deleted permanently.",
    "ReportlistReportwasdeletedpermanently": "Report was deleted permanently.",
    "ReportlistReportsweredeletedpermanently": "{} reports were deleted permanently.",
    "ReportlistXoutofyselectedreportsweredeletedpermanently": "{} out of {} selected reports were deleted permanently.",
    "ReportlistDeletepermanentlygenericfailurereason": "The failed report(s) might have been already permanently deleted or restored and no longer in bin.",
    "ReportlistMoveToBinCondition": "In future, do not show me this dialog box.",
    "ReportlistNoreportswerecopied": "No reports were copied.",
    "ReportlistReportwascopied": "Report was copied.",
    "ReportlistReportswerecopied": "{} reports were copied.",
    "ReportlistXoutofyselectedreportswerecopied": "{} out of {} selected reports were copied.",
    "ReportlistCopygenericfailurereason": "The failed report(s) might have been already moved to bin.",
    "ReportListCopyReportsSuccessfulMessage": "Successfully copied {} report(s)",
    "ReportlistOverrideExistingReport": "Tick if you want to override your existing Reports.",
    "ReportlistReportsKeptForThirtyDays": "Overridden reports will be held in the Recycle Bin for 30 days or until emptied.",
    "NAME": "LanguageMyReportList"
}